import API from '../../../helpers/request/api';

const api = () => new API();

const fetchPostComments = (postData) => {
  const { postId } = postData;
  const page = postData.page || 1;

  const query = {
    variables: { postId, page },
    query: `query community_post_comments($postId: String!, $page: Int!) {
      community_post_comments(
        community_post_id: $postId,
        page: $page,
        comment_id: ${postData.commentId}
      ) {
        id
        content
        moderation_state
        number_of_replies
        comment_id
        cached_votes_up
        liked_by_user
        best_comment
        medias {
          id
          url
          kind
        }
        user {
          id
          name
          photo
        }
        community_user {
          id
          permission
          is_active
          is_muted
        }
      }
    }`,
  };

  return api().get(query);
};

const countPostComments = (postId) => {
  const query = {
    variables: { postId },
    query: `query count_community_post_comments($postId: String!) {
      count_community_post_comments(community_post_id: $postId) {}
    }`,
  };

  return api().get(query);
};

const createComment = (commentData) => {
  const { content, postId, parentCommentId, videos, images, mentions } = commentData;
  const query = {
    variables: { content, videos, images, mentions },
    query: `mutation createCommunityPostComment($content: String!, $videos: [String], $images: [String], $mentions: [Int]) {
      createCommunityPostComment(input: {
        community_post_id: ${postId},
        content: $content,
        comment_id: ${parentCommentId},
        videos: $videos,
        images: $images,
        mentions: $mentions
      }) {
        community_post_comment {
          id
          content
          moderation_state
          number_of_replies
          comment_id
          cached_votes_up
          liked_by_user
          best_comment
          medias {
            id
            url
            kind
          }
          user {
            id
            name
            photo
          }
          community_user {
            id
            permission
            is_active
            is_muted
          }
        }
      }
    }`,
  };

  return api().get(query);
};

const updateComment = (commentData) => {
  const { content, id, videos, images, mentions } = commentData;
  const query = {
    variables: { content, videos, images, mentions },
    query: `mutation updateUserCommunityPostComment($content: String!, $videos: [String], $images: [String], $mentions: [Int]) {
      updateUserCommunityPostComment(input: {
        id: ${id},
        content: $content,
        videos: $videos,
        images: $images,
        mentions: $mentions
      }) {
        community_post_comment {
          id
          content
          moderation_state
          comment_id
          cached_votes_up
          liked_by_user
          best_comment
          medias {
            id
            url
            kind
          }
          user {
            id
            name
            photo
          }
          community_user {
            id
            permission
            is_active
            is_muted
          }
        }
      }
    }`,
  };

  return api().get(query);
};

const destroyComment = (commentId) => {
  const query = {
    query: `mutation destroyCommunityPostComment {
      destroyCommunityPostComment(input: {
        id: ${commentId}
      }) {
        message
      }
    }`,
  };

  return api().get(query);
};

const like = (commentId) => {
  const query = {
    query: `mutation likeCommunityPostComment {
      likeCommunityPostComment(input: {
        id: ${commentId}
      }) {
        community_post_comment {
          id
          content
          moderation_state
          comment_id
          cached_votes_up
          liked_by_user
          best_comment
          medias {
            id
            url
            kind
          }
          user {
            id
            name
            photo
          }
          community_user {
            id
            permission
            is_active
            is_muted
          }
        }
        message
      }
    }`,
  };

  return api().get(query);
};


const updateModerationState = (data) => {
  const { moderationState } = data;
  const query = {
    variables: { moderationState },
    query: `mutation updateAdminCommunityPostComment ($moderationState: String!) {
      updateAdminCommunityPostComment(
        input: {
          id: ${data.commentId},
          moderation_state: $moderationState
        }
      ) {
        community_post_comment {
          id
          content
          liked_by_user
          cached_votes_up
          moderation_state
          comment_id
          best_comment
          medias {
            id
            url
            kind
          }
          user {
            id
            name
            photo
          }
          community_user {
            id
            permission
            is_active
            is_muted
          }
        }
        message
      }
    }`,
  };

  return api().get(query);
};

const fetchById = (commentId) => {
  const query = {
    query: `query community_post_comment {
      community_post_comment(id: ${commentId})
      {
        id
        content
        moderation_state
        number_of_replies
        comment_id
        cached_votes_up
        liked_by_user
        best_comment
        medias {
          id
          url
          kind
        }
        user {
          id
          name
          photo
        }
        community_user {
          id
          permission
          is_active
          is_muted
        }
      }
    }`,
  };

  return api().get(query);
};

const fetchCommunityComments = (communityId, params) => {
  const { page, moderationState } = params;

  const query = {
    variables: { moderationState },
    query: `query community_comments($moderationState: [String]) {
      community_comments(
        community_id: "${communityId}",
        moderation_state: $moderationState,
        page: ${page || 1},
      )
      {
        id
        content
        moderation_state
        created_at
        updated_at
        best_comment
        user {
          id
          name
          photo
        }
        community_post {
          id
          title
          content
          created_at
          user {
            id
            name
            photo
          }
          community_user {
            id
            permission
            is_active
            is_muted
          }
        }
        community_user {
          id
          permission
          is_active
          is_muted
        }
        comment_id
        parent_comment {
          id
          content
          moderation_state
          created_at
          updated_at
          best_comment
          user {
            id
            name
            photo
          }
          community_user {
            id
            permission
            is_active
            is_muted
          }
        }
      }
    }`,
  };

  return api().get(query);
};

const countCommunityComments = (communityId, moderationState) => {
  const query = {
    variables: { moderationState },
    query: `query count_community_comments($moderationState: [String]) {
      count_community_comments(community_id: "${communityId}", moderation_state: $moderationState) {}
    }`,
  };

  return api().get(query);
};

const toggleBestComment = (comment) => {
  const query = {
    query: `mutation toggleBestComment {
      toggleBestComment(
        input: {
          id: ${comment.id}
        }
      )
      {
        community_post_comment {
          id
          content
          moderation_state
          number_of_replies
          comment_id
          cached_votes_up
          liked_by_user
          best_comment
          medias {
            id
            url
            kind
          }
          user {
            id
            name
            photo
          }
          community_user {
            id
            permission
            is_active
            is_muted
          }
        }
      }
    }`,
  };

  return api().get(query);
};

export default {
  createComment,
  fetchPostComments,
  countPostComments,
  updateComment,
  destroyComment,
  updateModerationState,
  like,
  fetchById,
  fetchCommunityComments,
  countCommunityComments,
  toggleBestComment,
};



// WEBPACK FOOTER //
// ./src/screens/Community/queries/comment.js